import { dayjs } from "~/utils/dayjs";

/**
 * Format a date to DD/MM/YYYY
 * @typedef {import('dayjs').Dayjs} Dayjs
 * @param {Dayjs | Date | string | undefined | null} date the date to format
 * @param {string=} format format of the given date
 * @returns {string}
 */
export default function (date, relative = false) {
  if (!date) {
    return "";
  }

  let format = "DD/MM/YYYY";

  if (relative && dayjs(date).year() === dayjs().year()) {
    format = "DD/MM";
  }

  return dayjs(date).format(format);
}
